/**
*
* Projects
*
*/

import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ProjectsList from 'Workspace/Projects/components/ProjectsList';
import ProjectPage from 'Workspace/Projects/components/ProjectPage';
import UnAuthorizedPage from 'components/UnAuthorizedPage';
import UnAvailableContent from 'components/UnAvailableContent';


const Projects = () => (
  <>
    <Switch>
      <Route path="/courseware/:projectId/unauthorized" component={UnAuthorizedPage} />
      <Route path="/courseware/:projectId/unavailable" component={UnAvailableContent} />
      <Route path="/courseware/:projectId" component={ProjectPage} />
      <Route path="/courseware" component={ProjectsList} />
      <Redirect to="/courseware" />
    </Switch>
  </>
);

export default Projects;
